export const BOROUGH_CENTROIDS = [
  {
    name: "Ahuntsic-Cartierville",
    coordinates: [45.531605383770994, -73.69422912597656],
    code: 79,
    zoom: 12,
  },
  {
    name: "Anjou",
    coordinates: [45.61108281735147, -73.56610184208351],
    code: 1274,
    zoom: 13,
  },
  {
    name: "Baie-d'Urfé",
    coordinates: [45.4166955896, -73.9140217669],
    code: 5224,
    zoom: 14,
  },
  {
    name: "Beaconsfield",
    coordinates: [45.4154120577, -73.8606353613],
    code: 1282,
    zoom: 13,
  },
  {
    name: "Côte-Saint-Luc",
    coordinates: [45.4682461372, -73.666276071],
    code: 1283,
    zoom: 14,
  },
  {
    name: "Côte-des-Neiges-Notre-Dame-de-Grâce",
    coordinates: [45.49094569262732, -73.63483428955078],
    code: 85,
    zoom: 13,
  },
  {
    name: "Dollard-des-Ormeaux",
    coordinates: [45.49142704415611, -73.81885528564453],
    code: 1284,
    zoom: 13,
  },
  {
    name: "Dorval",
    coordinates: [45.4567080267, -73.7519972806],
    code: 1285,
    zoom: 12,
  },
  {
    name: "Hampstead",
    coordinates: [45.4814748406, -73.6457776318],
    code: 5269,
    zoom: 14,
  },
  {
    name: "Kirkland",
    coordinates: [45.4528537127, -73.8587735621],
    code: 1287,
    zoom: 13,
  },
  {
    name: "L'Île-Bizard-Sainte-Geneviève",
    coordinates: [45.497208, -73.891314],
    code: 1286,
    zoom: 13,
  },
  {
    name: "L'Île-Dorval",
    coordinates: [45.4321793097, -73.7419886151],
    code: 5227,
    zoom: 16,
  },
  {
    name: "LaSalle",
    coordinates: [45.427274961571925, -73.62607130189726],
    code: 1277,
    zoom: 13,
  },
  {
    name: "Lachine",
    coordinates: [45.438392245813986, -73.67475813633689],
    code: 1288,
    zoom: 13,
  },
  {
    name: "Mercier-Hochelaga-Maisonneuve",
    coordinates: [45.57511957785422, -73.5369873046875],
    code: 82,
    zoom: 12,
  },
  {
    name: "Mont-Royal",
    coordinates: [45.5072037088, -73.6523627854],
    code: 1278,
    zoom: 13,
  },
  {
    name: "Montréal-Est",
    coordinates: [45.6288226082, -73.5208366362],
    code: 5228,
    zoom: 13,
  },
  {
    name: "Montréal-Nord",
    coordinates: [45.59338068769037, -73.62762451171875],
    code: 1275,
    zoom: 12,
  },
  {
    name: "Montréal-Ouest",
    coordinates: [45.460612252738706, -73.65028381347656],
    code: 5229,
    zoom: 13,
  },
  {
    name: "Outremont",
    coordinates: [45.51428088010101, -73.60889503594831],
    code: 1279,
    zoom: 13,
  },
  {
    name: "Pierrefonds-Roxboro",
    coordinates: [45.48104698981748, -73.84859561920166],
    code: 1289,
    zoom: 12,
  },
  {
    name: "Le Plateau-Mont-Royal",
    coordinates: [45.525670552210556, -73.58106421317045],
    code: 83,
    zoom: 13,
  },
  {
    name: "Pointe-Claire",
    coordinates: [45.452789, -73.811737],
    code: 1290,
    zoom: 13,
  },
  {
    name: "Rivière-des-Prairies-Pointe-aux-Trembles",
    coordinates: [45.65914920988703, -73.51349899432653],
    code: 87,
    zoom: 12,
  },
  {
    name: "Rosemont-La Petite-Patrie",
    coordinates: [45.55733331588203, -73.5812759399414],
    code: 81,
    zoom: 12,
  },
  {
    name: "Saint-Laurent",
    coordinates: [45.507941, -73.712339],
    code: 1291,
    zoom: 13,
  },
  {
    name: "Saint-Léonard",
    coordinates: [45.587271844347754, -73.59676700275871],
    code: 1276,
    zoom: 13,
  },
  {
    name: "Sainte-Anne-de-Bellevue",
    coordinates: [45.4236279348, -73.9393043867],
    code: 5231,
    zoom: 13,
  },
  {
    name: "Senneville",
    coordinates: [45.4336302706, -73.9607520172],
    code: 5230,
    zoom: 13,
  },
  {
    name: "Le Sud-Ouest",
    coordinates: [45.47265128615832, -73.58161926269531],
    code: 86,
    zoom: 13,
  },
  {
    name: "Verdun",
    coordinates: [45.462144, -73.563538],
    code: 1280,
    zoom: 15,
  },
  {
    name: "Ville-Marie",
    coordinates: [45.51216390141073, -73.5517489630759],
    code: 84,
    zoom: 13,
  },
  {
    name: "Villeray-Saint-Michel-Parc-Extension",
    coordinates: [45.55721311928203, -73.61801147460938],
    code: 80,
    zoom: 13,
  },
  {
    name: "Westmount",
    coordinates: [45.48805749706375, -73.59947204589844],
    code: 1281,
    zoom: 13,
  },
];
